/*
  product_carousel — prev/next arrows slide the track by one card.
  Imported page-wise by sections/product_carousel.liquid (defer), once per
  page no matter how many instances the page renders: the initialiser walks
  every .product-carousel on the page and binds each instance separately.
  Instances with no arrow buttons (nav_style = "cta", or the aside layout
  with its arrows switched off) no-op.

  The step is measured, not assumed: the two layouts set different gaps
  (--space-lg stacked, --space-card on the aside rail) and the card width is
  a percentage on a phone, so both come off the live computed style.

  Arrows also gain an end state — `.is-disabled` once the rail is against a
  stop. That only applies while the track is actually scrollable, so the
  stacked layout's desktop grid, which is not, is left exactly as it was.
*/
(function () {
  var FALLBACK_GAP = 32; /* var(--space-lg), the stacked layout's gap */

  function initCarousel(section) {
    if (section.dataset.carouselReady === 'true') return;
    section.dataset.carouselReady = 'true';

    var track = section.querySelector('[data-carousel-track]');
    var prev = section.querySelector('[data-carousel-prev]');
    var next = section.querySelector('[data-carousel-next]');
    if (!track || !prev || !next) return;

    function step() {
      var card = track.querySelector('.product-card');
      if (!card) return 0;
      var gap = parseFloat(getComputedStyle(track).columnGap);
      if (isNaN(gap)) gap = FALLBACK_GAP;
      return card.getBoundingClientRect().width + gap;
    }

    function scrollByCard(direction) {
      var distance = step();
      if (!distance) return;

      /* Honour reduced-motion: jump the rail rather than animating it. */
      var reduced =
        window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      track.scrollBy({
        left: direction * distance,
        behavior: reduced ? 'auto' : 'smooth'
      });
    }

    /* A track that cannot scroll gets no end state at all — otherwise the
       stacked layout's desktop grid would render both arrows dimmed. */
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      if (max <= 1) {
        prev.classList.remove('is-disabled');
        next.classList.remove('is-disabled');
        return;
      }
      prev.classList.toggle('is-disabled', track.scrollLeft <= 1);
      next.classList.toggle('is-disabled', track.scrollLeft >= max - 1);
    }

    prev.addEventListener('click', function () { scrollByCard(-1); });
    next.addEventListener('click', function () { scrollByCard(1); });

    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    /* Images decide the card's height and the rail's scrollWidth, so the
       first measurement has to wait for layout rather than parse. */
    if (typeof ResizeObserver === 'function') {
      new ResizeObserver(update).observe(track);
    }
    update();
  }

  function initAll(root) {
    (root || document).querySelectorAll('.product-carousel').forEach(initCarousel);
  }

  initAll();

  /* Theme editor: re-bind when a section is added or re-rendered. */
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
